import baseAPI from '@/api';
import { Success } from '@/models/success';
import { EditReferralVoucherRequestDto } from '@/services/dto/referral-vouchers/edit-referral-voucher-request.dto';
import { AxiosResponse } from 'axios';

export async function editReferralVoucher({
  voucherId,
  ...data
}: EditReferralVoucherRequestDto): Promise<Success> {
  const response: AxiosResponse<Success> = await baseAPI.patch<Success>(
    `/referral-vouchers/${voucherId}`,
    data,
  );

  return response.data;
}
